import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav
      id="nav-bar"
      className="navbar navbar-expand-lg navbar-white bg-body-tertiary fixed-top"
    >
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <Link to={"/"} className="navbar-brand text-primary mt-2 mt-lg-0">
            49P
          </Link>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item text-secondary">
              <Link to={"map"} className="nav-link">
                State Map
              </Link>
            </li>
            <li className="nav-item text-secondary">
              <Link to={"/contact"} className="nav-link">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
